module.exports = __webpack_public_path__ + "img/logo-h.376b55bd.svg";